import React from 'react'

import * as Layout from './Layout'
import * as Containers from './Containers'

/**
 */
const DefaultLoading = () => <span>Loading</span>

/**
 */
export const Default = ({
  components: {
    Message: messageComponents,
    CreateProjectLink: createProjectLinkComponents,
    loading: Loading = DefaultLoading,
    Layout: {
      Wrapper = Layout.Wrapper,
      Body = Layout.Body,
      Footer = Layout.Footer,
    } = {},
  } = {},
}) => {
  const [url, setUrl] = React.useState(null)

  React.useLayoutEffect(() => {
    setUrl(window.location.href)
  }, [])

  if (!url) {
    return <Loading />
  }

  return (
    <Wrapper>
      <Body>
        <Containers.Message
          components={messageComponents}
        />
      </Body>
      <Footer>
        <Containers.CreateProjectLink
          components={createProjectLinkComponents}
          redirectUri={url}
        />
      </Footer>
    </Wrapper>
  )
}
